import React from 'react'
import './Footer.css'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

function Footer() {
  return (
    <div className='footer_container'>
      <ul className='footer_sub_container bg-gradient-to-b from-rose-400 to-[#B00D23]'>
        <li>
          <div className="flex flex-col text-white no-underline ">
            <p className='text-red-300  text-sm'>Useful Links</p>
            <Link to="#" className='text-white no-underline text-sm hover:translate-x-2 cursor-pointer transition-all'>About Us</Link>
            <Link to="#" className='text-white no-underline text-sm mt-3 hover:translate-x-2 cursor-pointer transition-all'>Contact Us</Link>
            <Link to="/explore" className='text-white no-underline text-sm mt-3 hover:translate-x-2 cursor-pointer transition-all'>Explore</Link>
          </div>
        </li>
        <li>
          <div className="flex flex-col text-white no-underline ">
            <p className='text-red-300  text-sm'>Let Us Help You</p>
            <Link to="#" className='text-white no-underline text-sm hover:translate-x-2 cursor-pointer transition-all'>FAQ</Link>
            <Link to="#" className='text-white no-underline text-sm mt-3 hover:translate-x-2 cursor-pointer transition-all'>Payments</Link>
            <Link to="#" className='text-white no-underline text-sm mt-3 hover:translate-x-2 cursor-pointer transition-all'>Shipping</Link>
          </div>
        </li>
        <li>
          <div className="flex flex-col text-white no-underline">
            <p className='text-red-300  text-sm'>Policy</p>
            <a href="/terms/returnAndRefunds" smooth={true} duration={500}
            className='text-white no-underline text-sm hover:translate-x-2 cursor-pointer transition-all'
            >Return & Refund</a>
            <a href="/terms/orderCancellation" smooth={true} duration={500}
            className='text-white no-underline text-sm mt-3 hover:translate-x-2 cursor-pointer transition-all'
            >Order Cancellation</a>
            <a href="/terms/termsOfUSe" smooth={true} duration={500}
            className='text-white no-underline text-sm mt-3 hover:translate-x-2 cursor-pointer transition-all'
            >Terms of Use</a>
            <a href="/terms/security" smooth={true} duration={500}
            className='text-white no-underline text-sm mt-3 hover:translate-x-2 cursor-pointer transition-all'
            >Security</a>
            <a href="/terms/privacy" smooth={true} duration={500}
            className='text-white no-underline text-sm mt-3 hover:translate-x-2 cursor-pointer transition-all'
            >Privacy</a>
          </div>
        </li>
        <li>
          <div className="footer_content">
            <p className='text-red-300 text-sm mb-0'>Connect with Us</p>
            <li className='text-white flex gap-4'>
              <a href="https://www.facebook.com/InUtkarshita" target="_blank"><FacebookOutlinedIcon className='fb_icon'/></a>
              <Link to="#"><InstagramIcon className='instagram_icon'/></Link>
              <Link to="#"><TwitterIcon className='twitter_icon'/>  </Link>
              <Link to="#"><YouTubeIcon className='youtube_icon'/>  </Link>
            </li>
          </div>
        </li>
      </ul>
        
    </div>
  )
}

export default Footer